  <button kendoButton #anchor (click)="onToggle()" [primary]="true" look="outline">Ch: {{ GetHardwareChannel() }}</button>
  <kendo-popup class="metingenpopup"
    [animate]="animate"
    [anchor]="$any(anchor)"
    popupClass="content popup"
    *ngIf="show"
  >
    <button kendoButton (click)="onToggle()">Close</button>
  <app-meting-item-details   [measurementData]="measurementData"
                             [measurementDescription]="measurementDescription"
                             [fullChannelNumber]="fullChannelNumber"
  ></app-meting-item-details>

  </kendo-popup>


<td>
  <kendo-textbox [readonly]="true" [value]="GetValue()">
    <ng-template kendoTextBoxSuffixTemplate>
      <kendo-textbox-separator></kendo-textbox-separator>
    <small> {{ measurementData.measurementunit   }} </small>
    </ng-template>

  </kendo-textbox>
</td>
<td *ngIf="measurementDescription.department.length">

  <b> {{ measurementDescription.description }} </b>

</td>

<td *ngIf="measurementDescription.department.length">
  <i>{{ measurementDescription.department }} </i>
</td>


